//@flow
import React from 'react';
import {makeStyles} from '@material-ui/core';
import CustomEditor from '../../../../../configure/legal/components/CustomEditor/CustomEditor';

import ImageInput from '../../ImageInput';

import CustomTextField from '../../../../../../elements/CustomTextField/CustomTextField';
import CustomButton from '../../../../../../elements/CustomButton/CustomButton';
import {colors} from '../../../../../../assets/styles/colors';

import type {InputImage} from '../../ImageInput';
import type {BlogFormFieldsContent} from '../../../../constants';

const useStyles = makeStyles(theme => ({
  segmentForm: {
    width: '100%',
    height: '100%',
    position: 'relative',
    paddingTop: '3rem',
    display: 'flex',
    flexDirection: 'column',
    gap: '.75rem',
  },
  deleteButton: {
    position: 'absolute',
    top: 0,
    right: 0,
    color: colors.error,
    borderColor: colors.error,
  },
  textInput: {
    borderRadius: '.75rem',
    background: 'transparent',
    color: colors.grey900,

    '& .w-md-editor-toolbar button': {
      color: colors.grey900,
    },

    '& .w-md-editor-content': {
      padding: '0 !important',
    },
  },
  imageSection: {
    display: 'flex',
    gap: '.75rem',
    width: '100%',
  },
  imageInputContainer: {
    width: '100%',
    height: 'auto',
  },
}));

export type SegmentFormProps = {
  index: number,
  onDelete: () => void,
  subtitle: string,
  text: string,
  images: InputImage[],
  onChange: (content: BlogFormFieldsContent) => void,
};

export default function SegmentForm(props: SegmentFormProps) {
  const {index, onDelete, subtitle, text, images, onChange} = props;

  const classes = useStyles();

  return (
    <div className={classes.segmentForm}>
      {index !== 0 && (
        <CustomButton
          className={classes.deleteButton}
          variant="outlined"
          color="default"
          onClick={onDelete}
        >
          Eliminar segmento
        </CustomButton>
      )}
      <CustomTextField
        placeholder="Subtitulo"
        fullWidth
        value={subtitle}
        onChange={event => {
          const newSubtitle = event.target.value;

          onChange({
            subtitle: newSubtitle,
            text,
            images,
          });
        }}
      />
      <CustomEditor
        stickyToolbar
        height={128}
        idx={1}
        text={text}
        placeholder="Texto"
        onChange={text => {
          onChange({
            subtitle,
            text,
            images,
          });
        }}
        selected
        classes={{
          editorText: classes.textInput,
        }}
      />

      <div className={classes.imageSection}>
        {images.map((image, imageIndex) => {
          return (
            <div key={imageIndex} className={classes.imageInputContainer}>
              <ImageInput
                altInputLabelAsPlaceholder
                defaultAltText={image.alt}
                defaultImage={image.preview}
                aspectRatio={5 / 3}
                label="Sube una imagen (500 x 300)px"
                onChange={imageInput => {
                  const newImages = images.map((image, i) => {
                    if (i !== imageIndex) return image;

                    return {
                      alt: imageInput.alt || image.alt,
                      image: imageInput.image || image.image,
                      preview: image.preview,
                    };
                  });

                  onChange({
                    subtitle,
                    text,
                    images: newImages,
                  });
                }}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
}
